import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  static values = {
    activeClass: {
      type: String,
      default: 'border-blue-600 text-blue-600'
    },
    inactiveClass: {
      type: String,
      default:
        'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
    }
  }

  connect () {
    const url = new URL(window.location.href)

    const initialPanel =
      url.searchParams.get('tab') ||
      this.tabTargets[0]?.dataset.tabsPanelParam

    this.activate(initialPanel, false)
  }

  select (event) {
    this.activate(event.params.panel)
  }

  activate (panelName, updateHistory = true) {
    if (!this.hasPanel(panelName)) return

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle('hidden', panel.dataset.panel !== panelName)
    })

    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tabsPanelParam === panelName

      this.toggleClasses(tab, this.activeClassValue, active)
      this.toggleClasses(tab, this.inactiveClassValue, !active)

      tab.setAttribute('aria-selected', active.toString())
      tab.tabIndex = active ? 0 : -1
    })

    if (updateHistory) {
      const url = new URL(window.location.href)

      url.searchParams.set('tab', panelName)
      url.hash = ''

      history.replaceState(null, '', url)
    }
  }

  hasPanel (panelName) {
    return this.panelTargets.some((panel) => panel.dataset.panel === panelName)
  }

  toggleClasses (element, classNames, enabled) {
    classNames
      .split(/\s+/)
      .filter(Boolean)
      .forEach((className) => {
        element.classList.toggle(className, enabled)
      })
  }
}
